import { ViewChild, ElementRef, Component, OnInit } from '@angular/core';
import { Router, RouterModule, Routes } from '@angular/router';
import { HomeService } from '../../services/home.service';

@Component({
  selector: 'app-each-exercise',
  templateUrl: './each-exercise.component.html',
  styleUrls: ['./each-exercise.component.scss']
})
export class EachExerciseComponent implements OnInit {
  @ViewChild('progressBar') progressBar:ElementRef;
  exerciseId:any=null;
  eachExerciseObj:any={image:'',status:{}};
  allExercises:any=[];
  constructor(private homeService:HomeService, private router:Router) { }

  ngOnInit() {
    let url = this.router.url;
    this.exerciseId = url.split('/exercise/')[1];
    this.homeService.eachExerciseDetails(this.exerciseId).subscribe(res=>{
      this.exerciseId = res.id
      this.getExerciseDetails(this.exerciseId);
    });
  }

  getExerciseDetails(id) {
    this.homeService.eachExerciseDetails(id).subscribe(res=>{
      this.eachExerciseObj = res;
      let path_id = res.path_id;
      this.homeService.getPathDetails(path_id).subscribe(result=>{
        this.allExercises = result['results'];
        let progressBarElement= ''
        for(let idx of this.allExercises) {
          let className = "";
          //To append class name in li element based on the status of the exercise
          if(idx.status.status == 'active' || (this.eachExerciseObj.sequence == idx.sequence && idx.status.status == 'locked') || (this.eachExerciseObj.sequence == idx.sequence && idx.status.status == undefined)) {
            className = 'active'
          }else if(this.eachExerciseObj.sequence == idx.sequence && idx.status.status != 'locked' && idx.status.status != undefined) {
            className = 'redo'
          } else if(idx.status.status == 'completed') {
            className = 'completed'
          }
          //Skip last element in if condition as we don't need li.line element
          if(idx.sequence != this.allExercises.length) {
            progressBarElement += '<li class='+className+'><span>'+idx.sequence+'</span></li><li class="line"></li>'
          } else {
            progressBarElement += '<li class='+className+'><span>'+idx.sequence+'</span></li>'
          }
        }
        //Append li element to the html
        this.progressBar.nativeElement.innerHTML = progressBarElement;
      });
    });
  }

}



// WEBPACK FOOTER //
// /Volumes/Projects/WellBrain_Azure_Web/src/app/components/each-exercise/each-exercise.component.ts